import { jsx } from '@emotion/react/jsx-runtime';
import { linkContents } from './shared.js';
import { linkStyles } from './styles.js';
const ButtonLink = ({ priority = "primary", icon: iconSvg, iconSide = "left", cssOverrides, children, theme, ...props }) => {
    return /* @__PURE__ */ jsx("button", {
        css: linkStyles({
            isButton: true,
            priority,
            iconSvg,
            iconSide,
            cssOverrides,
            theme
        }),
        ...props,
        children: linkContents({ children, iconSvg, iconSide })
    });
};
export { ButtonLink };
